import { createSlice } from "@reduxjs/toolkit";

const exportSlice = createSlice({
  name: "exportCSVComponent",
  initialState: {
    activeExport: false,
    data: {},
    view: "",
  },
  reducers: {
    initExport: (state, action) => {
      state.activeExport = true;
      state.data = action.payload;
      state.view = action.payload?.view ?? "";
    },
    terminateExport: (state) => {
      state.activeExport = false;
      state.data = {};
    },
  },
});

export const selectStateExportCSV = (state) =>
  state.trackingApp.exportCSVComponent;

export const selectStateExportCSVActive = (state) =>
  state.trackingApp.exportCSVComponent.activeExport;

export const { initExport, terminateExport } = exportSlice.actions;

export default exportSlice.reducer;
